import type { Dispatch, SetStateAction } from "react";
import { useIntl } from "react-intl";
import SearchFilter from "~components/SearchFilter/SearchFilter";
import SelectCountryCode from "~components/SelectCountryCode/SelectCountryCode.tsx";
import SelectPersonGender from "~components/SelectPersonGender";
import SelectPersonStatus from "~components/SelectPersonStatus";
import type { PersonStatuses } from "~enums/personStatuses";
import type { LabelValue } from "~types/labelValue.ts";
import styles from "./AddPersonToRosterFilters.module.css";

type Props = {
  searchValue: string;
  setSearchValue: Dispatch<SetStateAction<string>>;
  setNationality: Dispatch<SetStateAction<string | undefined>>;
  setGender: Dispatch<SetStateAction<string | undefined>>;
  setStatus: Dispatch<SetStateAction<PersonStatuses | undefined>>;
  disabled?: boolean;
  resetPagination: () => void;
};

export const AddPersonToRosterFilters = ({
  setGender,
  setNationality,
  searchValue,
  setSearchValue,
  setStatus,
  disabled = false,
  resetPagination,
}: Props) => {
  const { formatMessage } = useIntl();

  return (
    <>
      <SelectCountryCode
        placeholder={formatMessage({ id: "nationality" })}
        onChange={(nationality) => {
          resetPagination();
          setNationality((nationality as LabelValue | undefined)?.value);
        }}
        className={styles.select}
        disabled={disabled}
      />
      <SelectPersonGender
        onChange={(gender) => {
          resetPagination();
          setGender((gender as LabelValue).value);
        }}
        className={styles.select}
        disabled={disabled}
      />
      <SelectPersonStatus
        onChange={(status) => {
          resetPagination();
          setStatus((status as LabelValue | undefined)?.value as PersonStatuses | undefined);
        }}
        className={styles.select}
        disabled={disabled}
      />
      <SearchFilter
        initial={searchValue}
        searchValue={searchValue}
        doSearch={(value) => {
          resetPagination();
          setSearchValue(value);
        }}
        placeholderIntlKey="search.two.letters"
      />
    </>
  );
};

export default AddPersonToRosterFilters;
